import React, { useEffect, useRef, useState } from 'react';
import './Product.css';

const SacsImprime = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const galleryImages = [
    '/images/sacs_imprime/5.jpeg',
    '/images/sacs_imprime/6.jpeg',
    '/images/sacs_imprime/7.jpeg',
    '/images/sacs_imprime/8.jpeg',
    '/images/sacs_imprime/1.jpg',
    '/images/sacs_imprime/2.jpg',
    '/images/sacs_imprime/3.jpg',
    '/images/sacs_imprime/4.jpg',
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className="product" ref={sectionRef}>
      <div className="product-container">
        <div className="product-layout">
          {/* Product Description */}
          <div className={`product-text ${isVisible ? 'fade-in' : ''}`}>
            <h2 className="product-title">Sacs Imprimé Personnalisè</h2>
            <p>
            Sa fabrication manuelle offre des possibilités illimitées en tant que support promotionnel qualitatif, pour transmettre une image de marque raffinée et élégante qui saura rehausser votre enseigne. 
            <br/><br/>
            Notre  sac papier vous permettra de vous distinguer de vos concurrents. Principalement utilisé comme sac cadeau et objet publicitaire dans le prêt-à-porter, en parfumerie, cosmétique, bijouterie et dans les métiers de bouche prestigieux, ou tout autre évènement, allant des salons aux cadeaux d’entreprises. 
            </p>
          </div>

          {/* Image Gallery */}
          <div className={`product-gallery ${isVisible ? 'fade-in-delay' : ''}`}>
            <div className="gallery-grid">
              {galleryImages.map((image, index) => (
                <div key={index} className="gallery-item">
                  <img src={image} alt={`Coffret à oreilles ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SacsImprime;